import React, { useState } from "react";
import VectorForm from "../VectorForm";
import DocumentIndexer from "../DocumentIndexer";
import ZipIndexer from "../ZipIndexer";
import "./VectorAdder.css";

/**
 * L'onglet « Zip » est revenu, mais rien à voir avec l'ancien.
 *
 * L'ancien traitait un lot à plat, en tâche de fond, sans dire ce qu'il faisait.
 * Le nouveau fait de la STRUCTURE un contrat : chaque dossier du zip porte un
 * code langue, les PDF y sont indexés dans cette langue, et un dossier au nom
 * inconnu est signalé puis laissé de côté. Il réutilise le chemin piloté par le
 * navigateur (prévisualisation puis lots), donc la même barre d'avancement réelle.
 *
 * « Master + traduction » avait aussi été retiré : l'alignement automatique de deux
 * révélé infidèle à la mesure — il recollait dans une paire une phrase cible
 * sans équivalent source (une mention réglementaire propre à une langue), et
 * perdait de vraies paires dès que les deux documents divergeaient un peu.
 * Une paire fausse est pire que pas de paire : elle est présentée au modèle
 * comme une traduction validée à reprendre telle quelle.
 *
 * Les vraies paires source→cible naissent désormais là où elles sont certaines :
 * à la validation d'une traduction dans l'admin xnet, où les deux versants du
 * même code_texte sont connus sans avoir à être devinés.
 *
 * PDF et Word passent par le même composant : depuis que l'ingestion est pilotée
 * par le navigateur, les deux suivent exactement le même chemin — découpage à
 * blanc, validation, envoi par lots. Seule l'extension acceptée les distingue.
 */
const TABS = [
    { key: "pdf",    label: "PDF",             hint: "Une brochure, prévisualisée avant indexation" },
    { key: "zip",    label: "Zip",            hint: "Une archive : un dossier par langue" },
    { key: "word",   label: "Word",            hint: "Un .docx, prévisualisé avant indexation" },
    { key: "manuel", label: "Saisie manuelle", hint: "Un texte isolé" },
];

export default function VectorAdder() {
    const [activeTab, setActiveTab] = useState("pdf");
    const active = TABS.find(t => t.key === activeTab);

    return (
        <section className="card" id="vector-adder">
            <div className="card__head">
                <h2>Alimenter la mémoire</h2>
                <p>{active?.hint}</p>
            </div>

            <nav id="vector-adder-nav" aria-label="Mode d'ajout">
                {TABS.map(tab => (
                    <button
                        key={tab.key}
                        type="button"
                        className={activeTab === tab.key ? "is-active" : ""}
                        aria-current={activeTab === tab.key ? "true" : undefined}
                        onClick={() => setActiveTab(tab.key)}
                    >
                        {tab.label}
                    </button>
                ))}
            </nav>

            <div className="card__body">
                {activeTab === "pdf" && (
                    <DocumentIndexer accept=".pdf" fileLabel="Brochure (PDF)" storagePrefix="pdf" />
                )}
                {activeTab === "zip" && <ZipIndexer />}
                {activeTab === "word" && (
                    <DocumentIndexer accept=".docx" fileLabel="Document (.docx)" storagePrefix="word" />
                )}
                {activeTab === "manuel" && <VectorForm />}
            </div>
        </section>
    );
}
